import React from "react";
import IInputBuilder from "../iInputBuilder/IInputBuilder";
import ICheck from "../iCheck/ICheck";
import ICheckBuilderProps from "./ICheckBuilder.props";
import ICheckBuilderState from "./ICheckBuilder.state";

export default class ICheckBuilder<INP extends string> extends IInputBuilder<
  INP,
  ICheckBuilderProps<INP>,
  ICheckBuilderState
> {
  render() {
    return <ICheck {...(this.props as any)} />;
  }
}
